import { CustomStructuredText } from "components/CustomStructuredText/CustomStructuredText";
import { useScreenSize } from "hooks/useScreenSize";
import { FC } from "react";
import { Image } from "react-datocms";
import Slider from "react-slick";
import { SliderWithImageAndStructuredTextFragment } from "services/datocms/generated";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

type SliderWithImageAndStrucutredTextProps = {
  sliderData: SliderWithImageAndStructuredTextFragment;
};

export const SliderWithImageAndStrucutredText: FC<
  SliderWithImageAndStrucutredTextProps
> = ({ sliderData }) => {
  const { isMobile } = useScreenSize();

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    dots: isMobile,
  };

  return (
    <div className="p-6">
      {sliderData?.header && (
        <h1 className="text-center my-20 text-3xl font-semibold">
          {sliderData?.header}
        </h1>
      )}

      <div className="w-full relative pb-[1px]">
        <Slider {...settings}>
          {sliderData?.slides.map((item) => {
            return (
              <div key={item.id}>
                <div className="flex justify-center items-center flex-col gap-4">
                  <div className="w-[100px] h-[100px] relative">
                    {item.image?.responsiveImage && (
                      <Image data={item.image.responsiveImage} />
                    )}
                  </div>
                  {item.text && (
                    <CustomStructuredText
                      className="text-center [&_p]:text-[#808080] [&_p]:text-[15px] [&_p]:my-2 [&_a]:text-primary"
                      content={item.text}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
